export const ResultType = {
    /**
     * Pass the quizId as the second paramater
     */
    Round: 'quizes',
    /**
     * Pass the month as the second paramater
     */
    Month: 'months',
    /**
     * Requires no additional paramaters
     */
    Total: 'total'
}
